import { NgModule } from '@angular/core';
import { NbCardModule, NbIconModule, NbInputModule, NbTreeGridModule, NbToggleModule, NbActionsModule, NbSpinnerModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';

import { ThemeModule } from '../../@theme/theme.module';
import { ArticlesRoutingModule, routedComponents } from './articles-routing.module';
import { FormsModule } from '@angular/forms';
import { NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { CKEditorModule } from 'ngx-ckeditor';
import { UpdateArticleComponent } from './edit-article/update-article.component';


@NgModule({
  imports: [
    NbCardModule,
    NbTreeGridModule,
    NbIconModule,
    NbInputModule,
    ThemeModule,
    ArticlesRoutingModule,
    Ng2SmartTableModule,
    FormsModule,
    NbToggleModule,
    NgbModule,
    NgMultiSelectDropDownModule, 
    CKEditorModule,
    NbActionsModule,
    NbSpinnerModule,
  ],
  entryComponents: [
    UpdateArticleComponent,
  ],
  declarations: [
    UpdateArticleComponent,
    ...routedComponents,
  ],
})
export class ArticlesModule { }
